export default __webpack_public_path__ + "static/media/tubal-ligation (2).30fbba5b.png";